import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

import { getErrorMessages } from 'src/auth/errorMessages';
import AnonymousNavigation from 'src/components/Navigation/AnonymousNavigation';
import Footer from 'src/enosikit/components/Footer';
import { AUTH_ERROR_DEFAULT, AUTH_ERROR_USER_DEACTIVATED } from 'src/util/constants';

/**
 * AuthErrorPage component displays an error message when there is an authentication error.
 * @param {object} root0
 * @param {AUTH_ERROR_DEFAULT|AUTH_ERROR_USER_DEACTIVATED} root0.errorType - Type of error
 * (right now only two types)
 * @returns {React.ReactElement} The AuthErrorPage component
 */
function AuthErrorPage({ errorType = AUTH_ERROR_DEFAULT }) {
  const intl = useIntl();
  const { description, heading, pageTitle } = getErrorMessages(intl, errorType);
  // In this case the user is logged out. So show them the login option
  const showLogin = errorType === AUTH_ERROR_USER_DEACTIVATED;

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageTitle}</title>
      </Helmet>

      <div className="d-flex flex-column" style={{ minHeight: '100vh' }}>
        {showLogin && (<AnonymousNavigation />)}

        <div className="d-flex align-items-center text-center justify-content-center flex-grow-1">
          <div className="text-center">
            <h1 className="mb-3">{heading}</h1>
            <p className="text-muted">
              {description}
            </p>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}

AuthErrorPage.propTypes = {
  errorType: PropTypes.oneOf([AUTH_ERROR_DEFAULT, AUTH_ERROR_USER_DEACTIVATED]),
};

export default AuthErrorPage;
